import { catchError, firstValueFrom, Observable, take, throwError } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private readonly http = inject(HttpClient);

  private apiUrl = environment.apiUrl;

  getServicesActive(): Promise<any> {
    return firstValueFrom(
      this.http.get(`${this.apiUrl}/services/active`).pipe(
        take(1),
        catchError(this.handleError)
      )
    );
  }

  getUsersActiveSubscriptions(): Promise<any> {
    return firstValueFrom(
      this.http.get(`${this.apiUrl}/user/active_subscriptions`).pipe(
        take(1),
        catchError(this.handleError)
      )
    );
  }

  private handleError(error: any): Observable<never> {
    console.error('API Error:', error);
    return throwError(() => new Error('An error occurred while fetching data. Please try again later.'));
  }
}
